import { ViewDetails } from '../../models/view-details.model';
import { RequestsTypesConstants } from '../requests-side-menu.constants';
import { TablePropertiesConstants } from '../table-properties.constant';

export class EServicesConstants {
    public static TICKETING_ESERVICES: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.TICKETING_ESERVICES_TABLE_COLUMNS,
        tableWithSelection: false
    };
    public static ESERVICES_HISTORY_FEILDS: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.ESERVICES_HISTORY_FILEDS_TABLE_COLUMNS,
        tableWithSelection: false
    };
}
